import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import backgroundimage from "../../assets/background2.png";
import backgroundimage1 from "../../assets/Background3.png";
import img1 from "../../assets/Pic.png";

const SecondComp = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      once: false,
    });
  }, []);

  return (
    <div
      className="min-h-[80%] bg-cover bg-center bg-no-repeat py-6 sm:py-8 lg:py-10"
      style={{ backgroundImage: `url(${backgroundimage})` }}
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-8 lg:gap-12 xl:gap-16">
          <div className="w-full lg:w-5/12 relative flex justify-center lg:justify-start">
            <div className="relative w-full max-w-[300px] sm:max-w-[400px] lg:max-w-[500px]">
              <img
                src={backgroundimage1}
                alt="Background Layer"
                className="w-full h-auto"
                data-aos="fade-right"
                data-aos-duration="1000"
              />

              <img
                src={img1}
                alt="Person"
                className="absolute top-0 left-2/8 transform -translate-x-1/2 w-full h-auto"
                data-aos="fade-right"
                data-aos-duration="1000"
                data-aos-delay="200"
              />
            </div>
          </div>

          <div className="w-full lg:w-7/12 flex flex-col gap-6">
            <h1
              className="text-2xl sm:text-3xl  md:text-4xl xl:text-5xl lg:text-3xl font-semibold text-center lg:text-left dmsans"
              data-aos="fade-left"
              data-aos-duration="1000"
            >
              "Would You Like to Know More About Me?"
            </h1>

            <div className="space-y-6">
              <p
                className="text-sm sm:text-base md:text-lg xl:text-xl lg:text-md  text-[#55586F] leading-relaxed tracking-wide heebo text-justify"
                data-aos="fade-left"
                data-aos-duration="1000"
                data-aos-delay="200"
              >
                In 2016, he introduced the virtual teaching system in Odisha,
                revolutionizing medical education by providing students with the
                ability to gain knowledge and hands-on experience equivalent to
                working with cadavers. This pioneering initiative has
                transformed the learning landscape for aspiring medical
                professionals in the region.
              </p>

              <p
                className="text-sm sm:text-base md:text-lg xl:text-xl lg:text-md text-[#55586F] leading-relaxed tracking-wide heebo text-justify"
                data-aos="fade-left"
                data-aos-duration="1000"
                data-aos-delay="400"
              >
                With a forward-thinking mindset, Sailesh Dani continues to
                explore and implement state-of-the-art technologies, driving
                progress and setting benchmarks in his areas of expertise. His
                dedication to innovation and excellence underscores his mission
                to enhance the quality of life and education through sustainable
                and modern solutions.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SecondComp;
